import { RootState } from '../../../store';

export const getCoursesSelector = (state: RootState) => state.courses;
export const getCoursesLoadMoreSelector = (state: RootState) => state.courses.loadMore;
export const getCoursesLoadingSelector = (state: RootState) => state.courses.isLoading;
